import React from 'react';
import { SearchIcon, StarIcon } from 'lucide-react';
interface MaterialsFilterPanelProps {
  cabinetMaterialSearch: string;
  setCabinetMaterialSearch: (search: string) => void;
  showOnlyCabinetFavorites: boolean;
  setShowOnlyCabinetFavorites: (show: boolean) => void;
  showOnlySelectedMaterials: boolean;
  setShowOnlySelectedMaterials: (show: boolean) => void;
}
export function MaterialsFilterPanel({
  cabinetMaterialSearch,
  setCabinetMaterialSearch,
  showOnlyCabinetFavorites,
  setShowOnlyCabinetFavorites,
  showOnlySelectedMaterials,
  setShowOnlySelectedMaterials
}: MaterialsFilterPanelProps) {
  return <div className="flex flex-col mb-4 gap-3" data-id="element-836">
      {/* Search input and Display Filter in the same row */}
      <div className="flex gap-3 items-center" data-id="element-837">
        {/* Search by name input */}
        <div className="relative flex-1" data-id="element-838">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-839">
            <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-840" />
          </div>
          <input type="text" value={cabinetMaterialSearch} onChange={e => setCabinetMaterialSearch(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full pl-10 p-2 dark:bg-darkbg-primary dark:border-darkbg-border dark:text-white" placeholder="Search by name..." data-id="element-841" />
        </div>
        {/* Display filter (ALL/Favorites) */}
        <div className="w-48" data-id="element-842">
          <p className="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1" data-id="element-843">
            Display Filter
          </p>
          <div className="flex border border-gray-300 rounded-lg overflow-hidden dark:border-darkbg-border w-full" data-id="element-844">
            <button className={`flex-1 px-3 py-1.5 text-sm font-medium ${!showOnlyCabinetFavorites ? 'bg-blue-500 text-white dark:bg-accent-blue' : 'bg-gray-50 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => setShowOnlyCabinetFavorites(false)} data-id="element-845">
              ALL
            </button>
            <button className={`flex-1 px-3 py-1.5 text-sm font-medium flex items-center justify-center ${showOnlyCabinetFavorites ? 'bg-blue-500 text-white dark:bg-accent-blue' : 'bg-gray-50 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => setShowOnlyCabinetFavorites(true)} data-id="element-846">
              <StarIcon className="h-3 w-3 mr-1" data-id="element-847" />
              Favorites
            </button>
          </div>
        </div>
      </div>
      {/* Coloring scope filter on its own row */}
      <div data-id="element-848">
        <p className="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1" data-id="element-849">
          Coloring Scope
        </p>
        <div className="flex border border-gray-300 rounded-lg overflow-hidden dark:border-darkbg-border w-full" data-id="element-850">
          <button className={`flex-1 px-3 py-1.5 text-sm font-medium ${!showOnlySelectedMaterials ? 'bg-blue-500 text-white dark:bg-accent-blue' : 'bg-gray-50 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => setShowOnlySelectedMaterials(false)} data-id="element-851">
            ALL
          </button>
          <button className={`flex-1 px-3 py-1.5 text-sm font-medium ${showOnlySelectedMaterials ? 'bg-blue-500 text-white dark:bg-accent-blue' : 'bg-gray-50 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => setShowOnlySelectedMaterials(true)} data-id="element-852">
            Selected
          </button>
        </div>
      </div>
    </div>;
}